module.exports = __webpack_public_path__ + "static/media/Greybag.8e24251e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Greybag.png
// module id = 940
// module chunks = 0 1 2 3 4 5 6 7